import { useMutation } from "@tanstack/react-query";
import { uploadContactsFile } from "../api/contactsApi";
import { useAuth } from "../../../Context/AuthContext";
import ReadFile from "../components/readFile";
import { ErrorMessage } from "../../../utils/toastify";

const useUploadFileToServer = ({ data, fileInformation, formik }) => {
  const auth = useAuth();
  const { token } = auth.getSessionData();

  return useMutation({
    mutationFn: async () => {
      const readFile = new ReadFile();
      const csv = await readFile.generateNewCSV(data);
      const formData = new FormData();
      formData.append("name", "csvfile");
      formData.append("filename", fileInformation.name);
      formData.append("csvfile", csv);
      formData.append("uid", formik.values.uiddatabase);

      const response = await uploadContactsFile({ token, formData });
      return response;
    },
    onSuccess: (response) => {
      if (response.error) {
        throw new Error(response.error);
      }
    },
    onError: () => {
      ErrorMessage("Error al subir el archivo");
    },
  });
};

export default useUploadFileToServer;
